import Alert from 'react-s-alert';

import PolyUtil from '../../../util/PolyUtil';
import {fetchPropertyRoommateGroups} from "./owner";
import {hideModal} from "../../../store/actions/display";

export const handleQualifyRoommateGroup = (prop_id, listing_id, group_id, form) => dispatch => {
    return PolyUtil.fetchWrapper('/api/landlord/properties/' + prop_id + '/listings/' + listing_id + '/roommate-groups/' + group_id + '/accept/',
        {
            method: 'POST',
            body: JSON.stringify({message: form.qualification_message})
        }
    ).then(() => {
        if (form.save_message) {
            delete form.save_message;
            return PolyUtil.fetchWrapper('/api/landlord/',
                {
                    method: 'PATCH',
                    body: JSON.stringify({
                        acceptance_message: form.qualification_message,
                        rejection_message: form.deferral_message
                    })
                }
            );
        }
    }).then(() => {
        return dispatch(fetchPropertyRoommateGroups(prop_id, listing_id));
    }).then(() => {
        return dispatch(hideModal('confirm_roommate_group_modal'));
    }).then(() => {
        Alert.success("Roommate group was successfully qualified");
    }).catch((error) => {
        console.log("Error: ", error);
        Alert.error(error.message[0]);
    });

};

export const handleDeferRoommateGroup = (prop_id, listing_id, group_id, form) => dispatch => {
    return PolyUtil.fetchWrapper('/api/landlord/properties/' + prop_id + '/listings/' + listing_id + '/roommate-groups/' + group_id + '/reject/',
        {
            method: 'POST',
            body: JSON.stringify({message: form.deferral_message})
        }
    ).then(() => {
        if (form.save_message) {
            delete form.save_message;
            return PolyUtil.fetchWrapper('/api/landlord/',
                {
                    method: 'PATCH',
                    body: JSON.stringify({
                        acceptance_message: form.qualification_message,
                        rejection_message: form.deferral_message
                    })
                }
            );
        }
    }).then(() => {
        return dispatch(fetchPropertyRoommateGroups(prop_id, listing_id));
    }).then(() => {
        return dispatch(hideModal('confirm_roommate_group_modal'));
    }).then(() => {
        Alert.success("Roommate group was successfully deferred");
    }).catch((error) => {
        console.log("Error: ", error);
        Alert.error(error.message[0]);
    });
};

export const fetchGroupPDF = (prop_id, listing_id, group_id, file_name) => dispatch => {
    return PolyUtil.fetchPDF('/api/landlord/properties/' + prop_id + '/listings/' + listing_id + '/roommate-groups/' + group_id + '/download-pdf-packet/',
        {
            method: 'GET'
        },
        file_name
    ).catch((error) => {
        console.log("Error: ", error);
    });
};



// WEBPACK FOOTER //
// ./src/containers/owner/actions/applicants.js